import { Dimensions } from '../../../cross-team-shared/types/misc';
import { makeRandomSubpoints, ShapeHelper } from './shape-helper';

export class PointHelper extends ShapeHelper {
  override makeRandomPoints(imageSize: Dimensions) {
    return makeRandomSubpoints(imageSize, 1);
  }
}
